<template v-if="href">
  <nuxt-link
    v-scroll-to="scrollTo"
    :to="href"
    :event="inEditor ? [] : 'click'"
    :href="href"
    :class="[name]"
    :target="blank"
    :rel="blank && 'noreferrer noopener'"
    aria-label="cms.label"
  >
    <slot v-if="!copy" />
    {{ copy }}
  </nuxt-link>
</template>

<script>
import { mapGetters } from 'vuex'
import Href from '@/mixins/href'

export default {
  mixins: [Href],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
    url: {
      type: String,
      default() {
        return null
      },
    },
    scrollTo: {
      type: String,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      name: 'a-link-v2',
    }
  },
  computed: {
    ...mapGetters({
      inEditor: 'globals/getInEditor',
    }),
    copy() {
      return (this.cms || {}).copy || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.a-link-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  color: inherit;
}
</style>
